import { defineMessages } from "react-intl";
const messages = defineMessages({
    noAccessDevices: {
        id: "app.sgt.accessDevices.table.noData.text",
        defaultMessage: "No access devices available.",
    },
    accessDevicesError: {
        id: "app.sgt.accessDevices.error.text",
        defaultMessage: "Something went wrong. Please try again later.",
    },
    name: {
        id: "app.sgt.accessDevices.table.head.name.text",
        defaultMessage: "Name",
    },
    location: {
        id: "app.sgt.accessDevices.table.head.location.text",
        defaultMessage: "Location",
    },
    deviceId: {
        id: "app.sgt.accessDevices.table.head.deviceID.text",
        defaultMessage: "Device ID",
    },
    keyBox: {
        id: "app.sgt.accessDevices.table.head.keyBox.text",
        defaultMessage: "Keybox",
    },
    deviceType: {
        id: "app.sgt.accessDevices.table.head.deviceType.text",
        defaultMessage: "Type",
    },
    model: {
        id: "app.sgt.accessDevices.table.head.model.text",
        defaultMessage: "Model",
    },
    manufacturer: {
        id: "app.sgt.accessDevices.table.head.manufacturer.text",
        defaultMessage: "Manufacturer",
    },
    address: {
        id: "app.sgt.accessDevices.table.head.address.text",
        defaultMessage: "Address",
    },
    property: {
        id: "app.sgt.accessDevices.table.head.property.text",
        defaultMessage: "Community",
    },
    associatedSpaces: {
        id: "app.sgt.accessDevices.table.head.associatedSpaces.text",
        defaultMessage: "Associated to",
    },
    spaceLabel: {
        id: "app.sgt.accessDevices.table.head.spaceLabel.text",
        defaultMessage: "Space",
    },
    spaceType: {
        id: "app.sgt.accessDevices.table.head.spaceType.text",
        defaultMessage: "Type",
    },
    deleteAccessDeviceSuccess: {
        id: "app.sgt.accessDevices.delete.success.text",
        defaultMessage: "Access device deleted successfully.",
    },
    deleteAccessDeviceTitle: {
        id: "app.sgt.accessDevices.delete.dialog.title.text",
        defaultMessage: "Delete Access Device",
    },
    deleteAccessDeviceDescription: {
        id: "app.sgt.accessDevices.delete.dialog.desciprtion.text",
        defaultMessage: "Are you sure you want to delete this access device? this will permanently delete the access device. Deleted access device’s linked space will be no longer supported for self-guided tour. Please type {deleteKey} to confirm.",
    },
    delete: {
        id: "app.sgt.accessDevices.delete.dialog.delete.button.text",
        defaultMessage: "Delete",
    },
    updateAccessDeviceSuccess: {
        id: "app.sgt.accessDevices.update.success.text",
        defaultMessage: "Access device updated successfully.",
    },
    updateAccessDeviceTitle: {
        id: "app.sgt.accessDevices.update.dialog.title.text",
        defaultMessage: "Configure Access Device",
    },
    update: {
        id: "app.sgt.accessDevices.update.dialog.update.button.text",
        defaultMessage: "Save",
    },
    updateFormDeviceIdentifier: {
        id: "app.sgt.accessDevices.update.form.deviceId.text",
        defaultMessage: "Device ID",
    },
    updateFormDeviceName: {
        id: "app.sgt.accessDevices.update.form.deviceName.text",
        defaultMessage: "Keybox Name",
    },
    updateFormDeviceNameTooltip: {
        id: "app.sgt.accessDevices.update.form.deviceName.text",
        defaultMessage: "Will be shown upon check-in",
    },
    updateFormDeviceType: {
        id: "app.sgt.accessDevices.update.form.deviceType.text",
        defaultMessage: "Device Type",
    },
    updateFormManufacturer: {
        id: "app.sgt.accessDevices.update.form.manufacturer.text",
        defaultMessage: "Manufacturer",
    },
    accessTypeLabel: {
        id: "app.sgt.accessDevices.update.form.accessType.text",
        defaultMessage: "Access Type",
    },
    deviceModelLabel: {
        id: "app.sgt.accessDevices.update.form.model.text",
        defaultMessage: "Model",
    },
    updateFormSpace: {
        id: "app.sgt.accessDevices.update.form.space.text",
        defaultMessage: "Select Space",
    },
    updateFormSpaceType: {
        id: "app.sgt.accessDevices.update.form.spaceType.text",
        defaultMessage: "Space Type",
    },
    updateFormProperty: {
        id: "app.sgt.accessDevices.update.form.property.text",
        defaultMessage: "Select Community",
    },
    updateFormDeviceInstruction: {
        id: "app.sgt.accessDevices.update.form.deviceInstruction.text",
        defaultMessage: "Device Instruction",
    },
    updateFormDeviceInstructionRequiredMessage: {
        id: "app.sgt.accessDevices.update.form.access.instructions.required.message",
        defaultMessage: "Device instructions message is required",
    },
    updateFormDeviceInstructionPlaceholder: {
        id: "app.sgt.accessDevices.update.form.deviceInstruction.placeholder",
        defaultMessage: "Text description of how a user would operate the access device",
    },
    updateFormLocationDescription: {
        id: "app.sgt.accessDevices.update.form.locationDescription.text",
        defaultMessage: "Location Description",
    },
    updateFormUnitInstructions: {
        id: "app.sgt.accessDevices.update.form.unitInstruction.text",
        defaultMessage: "Space Instruction",
    },
    updateFormUnitInstructionPlaceholder: {
        id: "app.sgt.accessDevices.update.form.unitInstruction.placeholder",
        defaultMessage: "Text description of how a user can navigate from the access device to the space",
    },
    updateFormLocationDescriptionPlaceholder: {
        id: "app.sgt.accessDevices.update.form.locationDescription.placeholder",
        defaultMessage: "Include instructions on how to navigate to the space. You can also include any details which you’d like to highlight about this space.",
    },
    accessDeviceLocationLabel: {
        id: "app.sgt.accessDevices.update.form.location.label",
        defaultMessage: "Access Device Location",
    },
    manualAccessLocationLabel: {
        id: "app.sgt.accessDevices.update.form.manualAccess.location.label",
        defaultMessage: "Location",
    },
    updateFormLatitude: {
        id: "app.sgt.accessDevices.update.form.location.latitude",
        defaultMessage: "Latitude",
    },
    updateFormLongitude: {
        id: "app.sgt.accessDevices.update.form.location.longitude",
        defaultMessage: "Longitude",
    },
    updateFormLocationDescriptionRequiredMessage: {
        id: "app.sgt.accessDevices.update.form.location.description.required.message",
        defaultMessage: "Location description is required",
    },
    actionsEdit: {
        id: "app.sgt.accessDevices.createUser.actions.edit.text",
        defaultMessage: "Edit",
    },
    actionsDelete: {
        id: "app.sgt.accessDevices.createUser.actions.delete.text",
        defaultMessage: "Delete",
    },
    associatedToUnits: {
        id: "app.sgt.associatedTo.actions.delete.text",
        defaultMessage: "units",
    },
    importingAccessDevices: {
        id: "app.sgt.accessDevices.importing.text",
        defaultMessage: "Importing access devices...",
    },
});
export default messages;
